import React, { useState } from 'react'
import MigrantsNotifications from './MigrantsNotifications'

const MigrantsSideBarRight = ({ setType, type, toggleSidebar }) => {
  const handleHideSidebar = () => {
    toggleSidebar()
  }
  const [typeMarkAllAsRead, setTypeMarkAllAsRead] = useState(null)

  if (type === 'Notifications') {
    return (
      <div className="sideBarRight px-0 pb-2">
        <div className="sideBarRight-title bg-gray pr-2 d-flex justify-content-between align-items-center">
          <h5 className="text-white">Centro de Notificaciones</h5>
          <div className="btn-group">
            <button
              className="btn btn-sm border-0"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="fa fa-ellipsis-h text-white" aria-hidden="true"></i>
            </button>
            <div
              className="dropdown-menu dropdown-menu-right"
              aria-labelledby="dropdownMenuButton"
              style={{ fontSize: '0.8rem' }}
            >
              <button
                className="dropdown-item"
                onClick={() => setTypeMarkAllAsRead('All')}
              >
                Marcar todas como leídas
              </button>
              <button
                className="dropdown-item"
                onClick={() => setTypeMarkAllAsRead('BeforeCurrentDate')}
              >
                Marcar leídas anteriores
              </button>
            </div>
            <button className="btn btn-sm border-0" onClick={handleHideSidebar}>
              <i className="fa fa-times text-white" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <MigrantsNotifications
          typeMarkAllAsRead={typeMarkAllAsRead}
          setTypeMarkAllAsRead={setTypeMarkAllAsRead}
        />
      </div>
    )
  }

  return <></>
}

export default MigrantsSideBarRight
